import PropTypes from 'prop-types';

export const File = {
  id: PropTypes.number,
  fileCategory: PropTypes.string,
  fileName: PropTypes.string,
  filePath: PropTypes.string,
};

export const Files = PropTypes.arrayOf(PropTypes.shape(File));
